// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3wxsg","insightsList":"newBusinessInsightsMenu_insightsList__fn4A9","active":"newBusinessInsightsMenu_active__1TydI"};